import React from "react";
import { useTranslation } from "react-i18next";
import Button from "@/components/ui/Button";
import { cn } from "@/lib/utils";

interface DataVisibilityToggleProps {
  onClick: () => void;
  columnsCount: number;
  isHiding: boolean; // trueの場合は「データを開く」ボタン
}

/**
 * データ表示/非表示切り替えボタンコンポーネント
 */
const DataVisibilityToggle: React.FC<DataVisibilityToggleProps> = ({
  onClick,
  columnsCount,
  isHiding,
}) => {
  const { t } = useTranslation("voiceek_ui");

  return (
    <tr className="relative">
      <td
        colSpan={columnsCount}
        className={cn(
          "text-center py-2 h-[30px] align-middle",
          isHiding
            && "before:content-[''] before:block before:absolute before:h-20 before:inset-0 before:bg-gradient-to-b before:from-transparent before:via-white/10 before:to-white before:pointer-events-none before:translate-y-[-80px]",
        )}
      >
        <Button
          onClick={onClick}
          className="px-4 py-1"
          variant="readmore"
        >
          {
            isHiding
              ? t("bi.table.showAllData") // 「データを開く」
              : t("bi.table.hideAllData") // 「データを閉じる」
          }
        </Button>
      </td>
    </tr>
  );
};

export default DataVisibilityToggle;
